import { useMemo } from "react";
import styles from "./index.module.scss";
import Icon from "../../../../common/icon";
import { isMoreThanOneYearAgo } from "../../../../../utils";

export default function Qty({ product }) {
  const catalog = product.CATALOG;

  const quantity = useMemo(() => {
    return catalog.QUANTITY;
  }, [catalog]);

  return (
    <div className={styles.Qty}>
      {quantity > 0 ? (
        <>
          <Icon id="yes" width={18} height={18} />
          <span className={styles.InStock}>В наличии: {quantity} шт</span>
        </>
      ) : (
        <span className={styles.OutOfStock}>
          {" "}
          {isMoreThanOneYearAgo(product.TIMESTAMP_X)
            ? "Нет в наличии"
            : "Распродано"}
        </span>
      )}
    </div>
  );
}
